export const AD_LANGUAGES = [
  ['en', 'English'], ['ko', '한국어'], ['mn', 'Монгол'], ['ja', '日本語'], ['zh', '简体中文'],
  ['zh-tw', '繁體中文'], ['vi', 'Tiếng Việt'], ['th', 'ไทย'], ['id', 'Bahasa Indonesia'],
  ['ms', 'Bahasa Melayu'], ['tl', 'Filipino'], ['ru', 'Русский'], ['es', 'Español'],
  ['fr', 'Français'], ['de', 'Deutsch'], ['pt', 'Português'], ['it', 'Italiano'],
  ['nl', 'Nederlands'], ['pl', 'Polski'], ['uk', 'Українська'], ['hi', 'हिन्दी'],
  ['ar', 'العربية'], ['tr', 'Türkçe'], ['bn', 'বাংলা'], ['ur', 'اردو'], ['fa', 'فارسی'],
].map(([value, label]) => ({ value, label }));

export const AD_ELEMENT_KEYS = ['badge', 'title', 'reward', 'description', 'button'];

export const AD_FIXED_TEXT_FIELDS = [
  { key: 'badgeTop', label: '배지 상단', elementKey: 'badge' },
  { key: 'badgeBottom', label: '배지 하단', elementKey: 'badge' },
  { key: 'title', label: '제목', elementKey: 'title' },
  { key: 'titleAccent', label: '강조 제목', elementKey: 'title' },
  { key: 'reward', label: '보상 문구', elementKey: 'reward' },
  { key: 'description', label: '설명', elementKey: 'description' },
  { key: 'buttonText', label: '버튼 문구', elementKey: 'button' },
];

const LANGUAGE_KOREAN_NAMES = {
  en: '영어', ko: '한국어', mn: '몽골어', ja: '일본어', zh: '중국어', 'zh-tw': '대만어',
  vi: '베트남어', th: '태국어', id: '인도네시아어', ms: '말레이어', tl: '필리핀어',
  ru: '러시아어', es: '스페인어', fr: '프랑스어', de: '독일어', pt: '포르투갈어',
  it: '이탈리아어', nl: '네덜란드어', pl: '폴란드어', uk: '우크라이나어', hi: '힌디어',
  ar: '아랍어', tr: '터키어', bn: '방글라데시어', ur: '우르두어', fa: '페르시아어',
};

const EXTRA_LANGUAGE_ALIASES = {
  kr: 'ko', kor: 'ko', korean: 'ko', 한글: 'ko',
  eng: 'en', english: 'en',
  jp: 'ja', jpn: 'ja', japanese: 'ja',
  '중국어(간체)': 'zh', 간체: 'zh', chinese: 'zh',
  '중국어(번체)': 'zh-tw', 번체: 'zh-tw', 대만중국어: 'zh-tw',
  br: 'pt', 'pt-br': 'pt', brazilian: 'pt', 브라질어: 'pt',
  filipino: 'tl', tagalog: 'tl',
  persian: 'fa', farsi: 'fa',
};

export const DEFAULT_TRANSLATION = {
  badgeTop: 'NIGHT CLUB',
  badgeBottom: 'CHALLENGE',
  title: '오늘의',
  titleAccent: 'CHALLENGES!!',
  reward: '미션 완료 시 최대 600P',
  description: '라운지 포인트와 이벤트 보상을 확인하세요.',
  buttonText: '라운지 바로가기',
};

const EN_TRANSLATION = {
  badgeTop: 'NIGHT CLUB',
  badgeBottom: 'CHALLENGE',
  title: "TODAY'S",
  titleAccent: 'CHALLENGES!!',
  reward: 'Complete missions and earn up to 600P',
  description: 'Check Lounge Points and event rewards.',
  buttonText: 'OPEN LOUNGE',
};

function element(x, y, width, height, fontSize, extra = {}) {
  return {
    x,
    y,
    width,
    height,
    fontSize,
    visible: true,
    align: 'left',
    color: '#ffffff',
    fontWeight: 800,
    ...extra,
  };
}

function withDynamicElements(branch) {
  return {
    ...branch,
    customTexts: Array.isArray(branch.customTexts) ? branch.customTexts : [],
    imageElements: Array.isArray(branch.imageElements) ? branch.imageElements : [],
  };
}

function desktopStandard() {
  return withDynamicElements({
    canvas: { width: 1167, height: 75 },
    background: { positionX: 50, positionY: 50, scale: 100, opacity: 100, overlayOpacity: 18 },
    badge: element(2.2, 11.5, 7.2, 76, 8, { align: 'center', color: '#ff55a4', fontWeight: 900 }),
    title: element(11, 13, 37, 27, 16, { color: '#ffffff', fontWeight: 950 }),
    reward: element(11, 47, 39, 14, 8, { color: '#ff56a6', fontWeight: 900 }),
    description: element(11, 67, 41, 13, 6.5, { color: '#b8bac6', fontWeight: 600 }),
    button: element(56, 26, 12, 46, 9, { align: 'center', color: '#ffffff', fontWeight: 850 }),
  });
}

function desktopCompact() {
  const layout = desktopStandard();
  layout.canvas = { width: 1167, height: 73 };
  layout.badge = { ...layout.badge, y: 10.8, height: 76.5 };
  layout.title = { ...layout.title, y: 12.5 };
  layout.reward = { ...layout.reward, y: 47.5 };
  layout.description = { ...layout.description, y: 68 };
  layout.button = { ...layout.button, y: 25.5 };
  return layout;
}

function desktopUltra() {
  const layout = desktopStandard();
  layout.canvas = { width: 1167, height: 68 };
  layout.badge = { ...layout.badge, x: 1.9, y: 11.5, width: 6.4, height: 75, fontSize: 7.5 };
  layout.title = { ...layout.title, x: 9.8, y: 11, fontSize: 15 };
  layout.reward = { ...layout.reward, x: 9.8, y: 46, fontSize: 7.6 };
  layout.description = { ...layout.description, x: 9.8, y: 68, fontSize: 6.2 };
  layout.button = { ...layout.button, x: 55.7, y: 25, height: 47, fontSize: 8.5 };
  return layout;
}

function mobilePortrait() {
  return withDynamicElements({
    canvas: { width: 355, height: 64 },
    background: { positionX: 70, positionY: 50, scale: 100, opacity: 100, overlayOpacity: 24 },
    badge: element(2.8, 13, 15, 72, 6.5, { align: 'center', color: '#ff55a4', fontWeight: 900 }),
    title: element(20, 11, 48, 30, 12.5, { color: '#ffffff', fontWeight: 950 }),
    reward: element(20, 47, 49, 16, 7, { color: '#ff56a6', fontWeight: 900 }),
    description: element(20, 68, 49, 14, 5.8, { color: '#b8bac6', fontWeight: 600 }),
    button: element(72, 27, 25, 46, 7.4, { align: 'center', color: '#ffffff', fontWeight: 850 }),
  });
}

function mobileTablet() {
  return withDynamicElements({
    canvas: { width: 732, height: 72 },
    background: { positionX: 68, positionY: 50, scale: 100, opacity: 100, overlayOpacity: 20 },
    badge: element(2.2, 12, 9.5, 74, 7.5, { align: 'center', color: '#ff55a4', fontWeight: 900 }),
    title: element(13.5, 12, 42, 28, 15, { color: '#ffffff', fontWeight: 950 }),
    reward: element(13.5, 47, 43, 15, 8, { color: '#ff56a6', fontWeight: 900 }),
    description: element(13.5, 68, 43, 13, 6.4, { color: '#b8bac6', fontWeight: 600 }),
    button: element(60, 26, 18, 47, 8.5, { align: 'center', color: '#ffffff', fontWeight: 850 }),
  });
}

export function normalizeAdLanguageKey(value) {
  const raw = String(value || '').trim().replace(/_/g, '-').toLowerCase();
  if (!raw) return 'en';
  if (raw === 'kr' || raw.startsWith('ko')) return 'ko';
  if (raw === 'zh-tw' || raw === 'zh-hant' || raw === 'zh-hk' || raw === 'zh-mo') return 'zh-tw';
  if (raw === 'zh-cn' || raw === 'zh-sg' || raw === 'zh-hans') return 'zh';
  if (raw === 'fil' || raw === 'ph' || raw.startsWith('fil-')) return 'tl';
  if (raw === 'br' || raw === 'pt-br' || raw.startsWith('pt-br-') || raw === 'pt-pt' || raw.startsWith('pt-pt-')) return 'pt';
  return raw.split('-')[0];
}

export function isRtlAdLanguage(value) {
  return ['ar', 'fa', 'ur'].includes(normalizeAdLanguageKey(value));
}

function isObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function deepMerge(base, patch) {
  const out = { ...base };
  if (!isObject(patch)) return out;
  Object.entries(patch).forEach(([key, value]) => {
    if (isObject(value) && isObject(out[key])) out[key] = deepMerge(out[key], value);
    else out[key] = value;
  });
  return out;
}

export function parseJsonObject(value, fallback = {}) {
  if (isObject(value)) return value;
  if (typeof value !== 'string' || !value.trim()) return fallback;
  try {
    const parsed = JSON.parse(value);
    return isObject(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

function buildAliasMap() {
  const map = new Map();
  const add = (alias, code) => {
    const key = String(alias || '').trim().toLowerCase();
    if (key) map.set(key, normalizeAdLanguageKey(code));
  };
  AD_LANGUAGES.forEach((item) => {
    add(item.value, item.value);
    add(item.label, item.value);
    add(LANGUAGE_KOREAN_NAMES[item.value], item.value);
  });
  Object.entries(EXTRA_LANGUAGE_ALIASES).forEach(([alias, code]) => add(alias, code));
  return map;
}

const LANGUAGE_ALIAS_MAP = buildAliasMap();
const LANGUAGE_ALIAS_PATTERN = Array.from(LANGUAGE_ALIAS_MAP.keys())
  .sort((a, b) => b.length - a.length)
  .map((value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  .join('|');

export function parseBulkTranslationText(value) {
  const text = String(value || '').replace(/\r\n/g, '\n').trim();
  if (!text) return {};
  const regex = new RegExp(`(^|[\\n\\r|;,])\\s*(${LANGUAGE_ALIAS_PATTERN})\\s*:\\s*`, 'giu');
  const matches = [];
  let match = regex.exec(text);
  while (match) {
    matches.push({ alias: match[2], valueStart: regex.lastIndex, matchStart: match.index });
    match = regex.exec(text);
  }
  const out = {};
  matches.forEach((item, index) => {
    const end = index + 1 < matches.length ? matches[index + 1].matchStart : text.length;
    const rawValue = text.slice(item.valueStart, end).replace(/[\s|;,]+$/g, '').trim();
    const code = LANGUAGE_ALIAS_MAP.get(String(item.alias).trim().toLowerCase());
    if (code) out[code] = rawValue;
  });
  return out;
}

export function formatBulkFieldFromTranslations(translations, fieldKey) {
  const source = isObject(translations) ? translations : {};
  const ordered = AD_LANGUAGES
    .map((item) => {
      const value = source[item.value]?.[fieldKey];
      if (value == null || String(value) === '') return null;
      return `${LANGUAGE_KOREAN_NAMES[item.value] || item.label}:${String(value)}`;
    })
    .filter(Boolean);
  return ordered.join(' | ');
}

export function createDefaultContentJson() {
  const translations = {
    ko: { ...DEFAULT_TRANSLATION },
    en: { ...EN_TRANSLATION },
  };
  const bulkFields = {};
  AD_FIXED_TEXT_FIELDS.forEach(({ key }) => {
    bulkFields[key] = formatBulkFieldFromTranslations(translations, key);
  });
  return {
    version: 2,
    defaultLanguage: 'ko',
    translations,
    bulkFields,
    customTexts: {},
  };
}

export function createDefaultLayoutJson() {
  return {
    version: 2,
    assets: [],
    desktop: {
      standard: desktopStandard(),
      compact: desktopCompact(),
      ultra: desktopUltra(),
    },
    mobile: {
      portrait: mobilePortrait(),
      tablet: mobileTablet(),
    },
  };
}

function normalizeCustomTexts(value) {
  if (!isObject(value)) return {};
  const out = {};
  Object.entries(value).forEach(([id, item]) => {
    if (!isObject(item)) return;
    const translations = {};
    Object.entries(isObject(item.translations) ? item.translations : {}).forEach(([lang, text]) => {
      translations[normalizeAdLanguageKey(lang)] = String(text ?? '');
    });
    const bulk = String(item.bulk || '').trim() || Object.entries(translations)
      .map(([lang, text]) => `${LANGUAGE_KOREAN_NAMES[lang] || lang}:${text}`)
      .join(' | ');
    const parsed = parseBulkTranslationText(bulk);
    out[id] = {
      id,
      label: String(item.label || 'Text'),
      bulk,
      translations: { ...translations, ...parsed },
    };
  });
  return out;
}

export function normalizeContentJson(value) {
  const defaults = createDefaultContentJson();
  const parsed = parseJsonObject(value, {});
  const merged = deepMerge(defaults, parsed);
  const rawTranslations = isObject(merged.translations) ? merged.translations : {};
  const translations = {};

  Object.entries(rawTranslations).forEach(([language, translation]) => {
    if (!isObject(translation)) return;
    const key = normalizeAdLanguageKey(language);
    translations[key] = { ...(translations[key] || {}), ...translation };
  });

  if (!translations.ko) translations.ko = { ...DEFAULT_TRANSLATION };
  if (!translations.en) translations.en = { ...EN_TRANSLATION };

  const bulkFields = { ...(isObject(merged.bulkFields) ? merged.bulkFields : {}) };
  AD_FIXED_TEXT_FIELDS.forEach(({ key }) => {
    if (!String(bulkFields[key] || '').trim()) {
      bulkFields[key] = formatBulkFieldFromTranslations(translations, key);
    }
    const parsedField = parseBulkTranslationText(bulkFields[key]);
    Object.entries(parsedField).forEach(([lang, text]) => {
      translations[lang] = { ...(translations[lang] || {}), [key]: text };
    });
  });

  const defaultLanguage = normalizeAdLanguageKey(merged.defaultLanguage || 'ko');
  if (!translations[defaultLanguage]) {
    translations[defaultLanguage] = { ...(translations.ko || DEFAULT_TRANSLATION) };
  }

  return {
    ...merged,
    version: 2,
    defaultLanguage,
    translations,
    bulkFields,
    customTexts: normalizeCustomTexts(merged.customTexts),
  };
}

function normalizeAsset(asset) {
  if (!isObject(asset) || !asset.id) return null;
  return {
    id: String(asset.id),
    name: String(asset.name || asset.originalFileName || 'image'),
    url: String(asset.url || ''),
    path: String(asset.path || ''),
    mimeType: String(asset.mimeType || ''),
    fileSize: Number(asset.fileSize || 0),
  };
}

function normalizeBranch(branch) {
  const next = withDynamicElements(branch || {});
  next.customTexts = next.customTexts.filter((item) => isObject(item) && item.id).map((item) => ({ ...item, id: String(item.id) }));
  next.imageElements = next.imageElements.filter((item) => isObject(item) && item.id && item.assetId).map((item) => ({ ...item, id: String(item.id), assetId: String(item.assetId) }));
  return next;
}

export function normalizeLayoutJson(value) {
  const merged = deepMerge(createDefaultLayoutJson(), parseJsonObject(value, {}));
  const normalized = {
    ...merged,
    version: 2,
    assets: (Array.isArray(merged.assets) ? merged.assets : []).map(normalizeAsset).filter(Boolean),
  };
  ['desktop', 'mobile'].forEach((family) => {
    normalized[family] = { ...normalized[family] };
    Object.keys(normalized[family] || {}).forEach((profile) => {
      normalized[family][profile] = normalizeBranch(normalized[family][profile]);
    });
  });
  return normalized;
}

export function getProfilesForDevice(device) {
  return device === 'mobile'
    ? [
        { value: 'portrait', label: 'Mobile Portrait · 355×64' },
        { value: 'tablet', label: 'Mobile Tablet · 732×72' },
      ]
    : [
        { value: 'standard', label: 'Desktop Standard · 1167×75' },
        { value: 'compact', label: 'Desktop Compact · 1167×73' },
        { value: 'ultra', label: 'Desktop Ultra · 1167×68' },
      ];
}

export function getLayoutBranch(layoutJson, device, profile) {
  const normalized = normalizeLayoutJson(layoutJson);
  const family = device === 'mobile' ? 'mobile' : 'desktop';
  const profiles = getProfilesForDevice(device);
  const selected = profiles.some((item) => item.value === profile) ? profile : profiles[0].value;
  return normalized[family][selected];
}

export function updateLayoutBranch(layoutJson, device, profile, nextBranch) {
  const normalized = normalizeLayoutJson(layoutJson);
  const family = device === 'mobile' ? 'mobile' : 'desktop';
  return {
    ...normalized,
    [family]: {
      ...normalized[family],
      [profile]: normalizeBranch(nextBranch),
    },
  };
}

export function mapLayoutProfiles(layoutJson, device, mapper) {
  const normalized = normalizeLayoutJson(layoutJson);
  const family = device === 'mobile' ? 'mobile' : 'desktop';
  const nextFamily = { ...normalized[family] };
  getProfilesForDevice(device).forEach(({ value }) => {
    nextFamily[value] = normalizeBranch(mapper(normalizeBranch(nextFamily[value]), value));
  });
  return { ...normalized, [family]: nextFamily };
}

export function resolveCustomText(contentJson, elementId, language) {
  const normalized = normalizeContentJson(contentJson);
  const item = normalized.customTexts?.[elementId];
  if (!item) return '';
  const selected = normalizeAdLanguageKey(language);
  const fallback = normalizeAdLanguageKey(normalized.defaultLanguage || 'ko');
  return item.translations?.[selected]
    ?? item.translations?.[fallback]
    ?? item.translations?.ko
    ?? item.translations?.en
    ?? Object.values(item.translations || {})[0]
    ?? '';
}
